import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
//import VueFacebookPixel from 'vue-facebook-pixel'

createApp(App).use(router).mount('#app');
